// Arabic strings for the calendars stream (PD-011: development draft, unreviewed until H-10).
import type { enCalendars } from './en-calendars.ts';
import type { Message } from './types.ts';

export const arCalendars: { readonly [K in keyof typeof enCalendars]: Message } = {
  // ------------------------------------------------------------ API messages
  'api.calendarEntitlement': 'لا تملك مؤسستك الصلاحية التجارية لمزوّد التقويم هذا.',
  'api.calendarTestRequired': 'اختبر الإعدادات الحالية بنجاح قبل تفعيل الاتصال.',
  'api.calendarConnectionInactive': 'اتصال التقويم هذا غير مفعّل.',
  'api.calendarSimulatorOnly': 'أدوات المحاكاة متاحة فقط للاتصالات المحاكاة خارج بيئة الإنتاج.',
  'api.calendarMeetingNotDraftable': 'لا يمكن إنشاء مسودة زيارة من هذا الاجتماع الآن.',
  'api.calendarRevisionChanged': 'تغيّر الاجتماع مجدداً في التقويم. راجع أحدث نسخة.',
  'api.calendarReviewIncomplete': 'بعض تغييرات التقويم لم تنعكس على الزيارة بعد. طبّقها أو تجاهل المراجعة.',
  'api.roomAlreadyLinked': 'هذه القاعة أو تقويم المورد مرتبط بالفعل.',
  'api.roomConflictClosed': 'تمت معالجة تعارض القاعة هذا بالفعل.',
  'api.preregLinkNotEligible': 'لم يعد بالإمكان إرسال رابط تسجيل مسبق لهذا الشخص.',
  'api.preregNothingRequired': 'لا تطلب هذه الزيارة شيئاً من الزائر قبل الوصول، لذلك لا حاجة إلى رابط تسجيل مسبق.',
  // ------------------------------------------------------------ validation
  'v.calendarDomain': 'أدخِل نطاقاً مثل example.com.',
  'v.calendarRef': 'أدخِل صندوق بريد أو معرّف تقويم دون مسافات.',
  'v.calendarGuid': 'أدخِل معرّف الدليل (المستأجر)، وهو GUID مثل 00000000-0000-0000-0000-000000000000.',
  'v.calendarDomainsRequired': 'أضِف أولاً نطاقاً واحداً على الأقل من نطاقات البريد الخاصة بمؤسستك.',
  'v.calendarHostUnresolved': 'تعذّر ربط مضيف بهذا التقويم. اختر المضيف.',
  'v.calendarDuplicate': 'هذا التقويم مُراقَب بالفعل.',
  'v.calendarFormat': 'صيغة الحدث هذه لا تطابق مزوّد الاتصال.',
  'v.calendarUnknown': 'هذا التقويم ليس ضمن التقاويم المُراقَبة لهذا الاتصال.',
  'v.calendarRoomOnly': 'يمكن ربط القاعات فقط بتقويم مورد.',
  'v.calendarConnectionUnknown': 'اختر اتصال تقويم مفعّلاً.',
  'v.calendarResolution': 'لا ينطبق هذا الحل على هذا النوع من التعارض.',
  'v.calendarSiteUnknown': 'اختر موقعاً مفعّلاً.',
  // ------------------------------------------------------------ المستخدمون والصلاحيات ← التقاويم
  'cal.tab': 'التقاويم',
  'cal.admin.sub': 'اربط Microsoft 365 أو Google Workspace ليتمكن المضيفون من تحويل الاجتماعات التي تضم ضيوفاً خارجيين إلى زيارات.',
  'cal.admin.panel': 'اتصالات التقويم',
  'cal.admin.panelSub': 'تصبح الاجتماعات مسودات زيارات لمضيفها. لا يُقدَّم شيء ولا يُعتمد ولا يُرسل حتى يتصرف المضيف؛ وتنطبق الموافقات والسياسة كما في أي زيارة.',
  'cal.admin.simulatorNote': 'لا يوجد مزوّد تقويم متصل في هذا الإصدار: تستخدم الاتصالات محاكيات محلية. موافقة Microsoft 365 أو Google الفعلية قرار لاحق.',
  'cal.admin.connections': 'الاتصالات',
  'cal.admin.connectionsSub': 'اتصال واحد لكل مستأجر Microsoft 365 أو نطاق Google Workspace.',
  'cal.admin.add': 'إضافة اتصال',
  'cal.admin.none': 'لا توجد اتصالات تقويم بعد.',
  'cal.admin.noEntitlement': 'لا تملك مؤسستك صلاحية التقويم. يمكن عرض الاتصالات الحالية وتعطيلها.',
  'cal.col.connection': 'الاتصال',
  'cal.col.status': 'الحالة',
  'cal.col.tested': 'الاختبار',
  'cal.col.calendars': 'التقاويم المُراقَبة',
  'cal.col.attention': 'يحتاج إلى متابعة',
  'cal.col.action': 'الإجراء',
  'cal.col.meeting': 'الاجتماع',
  'cal.col.when': 'الموعد ({zone})',
  'cal.col.visitors': 'الضيوف الخارجيون',
  'cal.col.organiser': 'المنظِّم',
  'cal.col.calendar': 'التقويم',
  'cal.col.host': 'المضيف',
  'cal.col.subscription': 'الإشعارات',
  'cal.col.lastSync': 'آخر قراءة',
  'cal.open': 'فتح',
  'cal.openLabel': 'فتح {name}',
  'cal.simulated': 'محاكي',
  'cal.notEntitled': 'غير مشمول بالصلاحية',
  'cal.tested.yes': 'تم اختبار النسخة الحالية',
  'cal.tested.no': 'غير مُختبر',
  'cal.never': 'أبداً',
  'cal.untitled': 'اجتماع بلا عنوان',
  'cal.add.title': 'إضافة اتصال تقويم',
  'cal.add.sub': 'يُخزَّن السر مشفّراً ولا يُعرض مرة أخرى.',
  'cal.add.provider': 'المزوّد',
  'cal.add.displayName': 'الاسم',
  'cal.add.directoryTenantId': 'معرّف الدليل (المستأجر)',
  'cal.add.directoryTenantIdHint': 'دليل Microsoft Entra الخاص بمؤسستك.',
  'cal.add.clientId': 'معرّف التطبيق (العميل)',
  'cal.add.workspaceDomain': 'نطاق مساحة العمل',
  'cal.add.serviceAccountEmail': 'حساب الخدمة',
  'cal.add.clientSecret': 'سر العميل',
  'cal.add.serviceAccountKey': 'مفتاح حساب الخدمة',
  'cal.add.secretHint': 'للكتابة فقط. اتركه فارغاً لإضافته لاحقاً.',
  'cal.add.domains': 'نطاقات البريد الخاصة بمؤسستك',
  'cal.add.domainsHint': 'مفصولة بفواصل. يُعامَل الحاضرون من خارج هذه النطاقات بوصفهم زواراً.',
  'cal.add.consentNote': 'منح الإذن للمزوّد (موافقة المسؤول) يتم لدى المزوّد وليس جزءاً من هذا الإصدار.',
  'cal.add.create': 'إضافة الاتصال',
  'cal.detail.eyebrow': 'اتصال تقويم',
  'cal.detail.back': '→ كل اتصالات التقويم',
  'cal.detail.simulated': 'يستخدم هذا الاتصال محاكياً محلياً، لا مزوّد تقويم حقيقياً.',
  'cal.detail.facts': 'الاتصال',
  'cal.detail.adapter': 'المحوّل',
  'cal.detail.secret': 'السر',
  'cal.detail.secretSet': 'مُعيَّن (النسخة {version})',
  'cal.detail.secretNone': 'غير مُعيَّن',
  'cal.detail.domains': 'النطاقات الداخلية',
  'cal.detail.autoDraft': 'المسودات التلقائية',
  'cal.detail.test': 'اختبار الاتصال',
  'cal.detail.testOk': 'قبِل المزوّد الإعدادات.',
  'cal.detail.activate': 'تفعيل',
  'cal.detail.activateTitle': 'تفعيل هذا الاتصال؟',
  'cal.detail.activateSub': 'تبدأ التقاويم المُراقَبة باستلام الإشعارات وتُقرأ وفق الجدول.',
  'cal.detail.disable': 'تعطيل',
  'cal.detail.disableTitle': 'تعطيل هذا الاتصال؟',
  'cal.detail.disableSub': 'لن يُقرأ أو يُنشر شيء بعد الآن. تبقى الزيارات الحالية كما هي.',
  'cal.detail.settings': 'تعديل الإعدادات',
  'cal.detail.rotate': 'استبدال السر',
  'cal.detail.rotateTitle': 'استبدال السر',
  'cal.detail.rotateSub': 'يُخزَّن السر الجديد مشفّراً؛ اختبر الاتصال مجدداً بعد ذلك.',
  'cal.detail.register': 'عنوان الإشعارات',
  'cal.detail.registerSub': 'المكان الذي يرسل إليه المزوّد إشعارات التغيير.',
  'cal.detail.registerNote': 'يُتحقق من الإشعارات ولا تؤدي إلا إلى قراءة التقويم؛ ولا تغيّر أي زيارة بنفسها.',
  'cal.settings.title': 'إعدادات الاتصال',
  'cal.settings.sub': 'قيم السياسة للاجتماعات الواردة من هذا الاتصال.',
  'cal.settings.defaultSite': 'الموقع الافتراضي',
  'cal.settings.defaultSiteHint': 'يُستخدم عندما لا تحدد القاعة المرتبطة ولا موقع مكتب المضيف ذلك.',
  'cal.settings.defaultCategory': 'فئة الزائر الافتراضية',
  'cal.settings.defaultCategoryHint': 'رمز الفئة المعبّأ مسبقاً في المسودات، مثل business.',
  'cal.settings.horizon': 'عدد الأيام المقبلة للاستيراد',
  'cal.settings.autoDraft': 'إنشاء مسودات زيارات تلقائياً للمضيفين المرتبطين',
  'cal.settings.matchByEmail': 'مطابقة المنظِّمين بالمضيفين عبر البريد ضمن النطاقات الداخلية',
  'cal.settings.note': 'لا تُقدَّم المسودات تلقائياً أبداً. يراجعها المضيفون ويقدّمونها.',
  'cal.watched.title': 'التقاويم المُراقَبة',
  'cal.watched.sub': 'تقاويم المضيفين التي تُستورد اجتماعاتها. كل تقويم يخص مضيفاً واحداً.',
  'cal.watched.add': 'مراقبة تقويم',
  'cal.watched.addTitle': 'مراقبة تقويم مضيف',
  'cal.watched.addSub': 'يُعثر على المضيف عبر هوية الدخول المرتبطة به أو معرّفه في الدليل أو — إن سُمح — بريده الإلكتروني.',
  'cal.watched.ref': 'صندوق البريد أو معرّف التقويم',
  'cal.watched.refHint': 'مثل عنوان البريد الإلكتروني للمضيف.',
  'cal.watched.ownerEntra': 'معرّف الكائن في Entra (اختياري)',
  'cal.watched.ownerGoogle': 'معرّف مستخدم Google (اختياري)',
  'cal.watched.ownerHint': 'يُستخدم لمطابقة المضيف عبر هويته المرتبطة.',
  'cal.watched.host': 'المضيف',
  'cal.watched.hostHint': 'اختر فقط عندما لا تجد المطابقة التلقائية أحداً؛ ويُسجَّل الاختيار في التدقيق.',
  'cal.watched.hostAuto': 'مطابقة تلقائية',
  'cal.watched.none': 'لا تُراقَب أي تقاويم بعد.',
  'cal.watched.syncNow': 'قراءة الآن',
  'cal.watched.expires': 'يُجدَّد قبل {at}',
  'cal.watched.needsSync': 'تغييرات بانتظار القراءة',
  'cal.watched.result': '{fetched} مقروءة · {created} جديدة · {updated} محدّثة · {duplicates} مكررة · {stale} قديمة · {drafted} مسودات',
  'cal.watched.resubscribed': 'أُعيد إنشاء قناة الإشعارات المنتهية؛ وقُرئت التغييرات الفائتة.',
  'cal.watched.resynced': 'طلب المزوّد قراءة كاملة؛ ولم يتكرر شيء.',
  'cal.attention.title': 'اجتماعات تحتاج إلى متابعة',
  'cal.attention.sub': 'اجتماعات بضيوف خارجيين تعذّر تحويلها إلى مسودة. عناوين الضيوف مُقنّعة.',
  'cal.attention.none': 'لا شيء يحتاج إلى متابعة.',
  'cal.sim.title': 'المحاكي',
  'cal.sim.sub': 'للتطوير فقط: أنشئ اجتماعات محاكاة وغيّرها وألغها واختبر معالجة الأعطال.',
  'cal.sim.calendar': 'التقويم',
  'cal.sim.eventId': 'معرّف الحدث',
  'cal.sim.eventIdHint': 'كرّر معرّفاً لتغيير ذلك الاجتماع.',
  'cal.sim.subject': 'الموضوع',
  'cal.sim.guests': 'الحاضرون',
  'cal.sim.guestsHint': 'عناوين بريد مفصولة بفواصل؛ العناوين التي تبدأ بـ "room" قاعات.',
  'cal.sim.start': 'البداية',
  'cal.sim.end': 'النهاية',
  'cal.sim.upsert': 'حفظ الاجتماع',
  'cal.sim.cancel': 'إلغاء الاجتماع',
  'cal.sim.deliver': 'تسليم الإشعارات (مكررة ومعكوسة)',
  'cal.sim.expireWatch': 'إنهاء الإشعارات',
  'cal.sim.expireCursor': 'نسيان موضع المزامنة',
  'cal.sim.timeout': 'القراءة التالية تنتهي مهلتها',
  'cal.sim.state': '{pending} إشعارات بالانتظار · {delivered} مُسلَّمة',
  'cal.provider.microsoft': 'Microsoft 365',
  'cal.provider.google': 'Google Workspace',
  'cal.kind.user': 'تقويم مضيف',
  'cal.kind.room': 'تقويم قاعة',
  'cal.resolution.identity_link': 'عبر الهوية المرتبطة',
  'cal.resolution.external_id': 'عبر معرّف الدليل',
  'cal.resolution.email': 'عبر البريد الإلكتروني',
  'cal.resolution.administrator': 'باختيار مسؤول',
  'cal.sub.pending': 'لم يُشترك بعد',
  'cal.sub.active': 'يستلم',
  'cal.sub.expired': 'منتهٍ',
  'cal.sub.failed': 'فشل',
  'cal.sub.disabled': 'معطّل',
  'cal.outcome.succeeded': 'نجح',
  'cal.outcome.failed': 'فشل',
  'cal.outcome.unknown': 'النتيجة غير معروفة',
  'cal.outcome.skipped': 'تم التخطي',
  'cal.outcome.partial': 'أُنجز جزئياً',
  'cal.error.credentials_missing': 'لم يُعيَّن أي سر.',
  'cal.error.credentials_rejected': 'رفض المزوّد بيانات الاعتماد.',
  'cal.error.configuration_invalid': 'إعدادات المزوّد غير مكتملة.',
  'cal.error.adapter_unavailable': 'لا يتوفر محوّل لهذا المزوّد في هذا النشر.',
  'cal.error.timeout': 'لم يُجب المزوّد في الوقت المحدد؛ النتيجة غير معروفة وسيُتحقق منها مجدداً.',
  'cal.error.simulated_failure': 'فشل المزوّد المحاكى.',
  'cal.error.provider_error': 'أبلغ المزوّد عن خطأ.',
  'cal.error.entitlement_missing': 'لم تعد المؤسسة تملك الصلاحية.',
  'cal.error.connection_inactive': 'الاتصال غير مفعّل.',
  'cal.error.busy': 'هناك قراءة أخرى قيد التنفيذ.',
  'cal.error.declined': 'رفض تقويم المورد الحجز.',
  'cal.mapping.linked': 'أُنشئت زيارة',
  'cal.mapping.no_visitors': 'لا ضيوف خارجيين',
  'cal.mapping.host_unresolved': 'لم يُعثر على المضيف',
  'cal.mapping.host_without_account': 'المضيف بلا حساب دخول',
  'cal.mapping.host_not_permitted': 'لا يحق للمضيف التخطيط هنا',
  'cal.mapping.site_unresolved': 'يلزم اختيار الموقع',
  'cal.mapping.awaiting_host': 'بانتظار المضيف',
  'cal.mapping.cancelled': 'أُلغي في التقويم',
  'cal.mapping.not_organizer': 'ليس المنظِّم',
  'cal.mapping.past': 'مضى',
  'cal.mapping.unscheduled': 'لا وقت قابل للاستخدام',
  'cal.mappingHint.no_visitors': 'يحضر الزملاء فقط.',
  'cal.mappingHint.host_unresolved': 'راقب تقويم المنظِّم أو اربط هويته.',
  'cal.mappingHint.host_without_account': 'يمكن لمضيف مفوَّض إنشاء المسودة.',
  'cal.mappingHint.host_not_permitted': 'لا تشمل صلاحية المضيف تخطيط زيارات في هذا الموقع.',
  'cal.mappingHint.site_unresolved': 'اختر الموقع عند إنشاء المسودة.',
  'cal.mappingHint.awaiting_host': 'أنشئ المسودة عندما تكون جاهزاً.',
  'cal.mappingHint.not_organizer': 'تقويم المنظِّم نفسه هو الذي يحدد الزيارة.',
  'cal.mappingHint.unscheduled': 'حدّد الأوقات في الزيارة.',
  // ------------------------------------------------------------ المضيف: الاجتماعات ومراجعة التقويم
  'cal.meetings.title': 'من تقويمك',
  'cal.meetings.sub': 'اجتماعاتك التي تضم ضيوفاً خارجيين. لا تُقدَّم المسودات نيابة عنك أبداً.',
  'cal.meetings.foot': 'التغييرات التي تُجرى في تقويمك بعد تقديم الزيارة تنتظر مراجعتك هنا.',
  'cal.reviewPending': 'تغييرات تقويم بانتظار المراجعة',
  'cal.reviewChanges': 'مراجعة التغييرات',
  'cal.openVisit': 'فتح الزيارة',
  'cal.createDraft': 'إنشاء مسودة زيارة',
  'cal.draft.title': 'إنشاء مسودة زيارة',
  'cal.draft.sub': 'تأخذ المسودة موضوع الاجتماع ووقته وقاعته وضيوفه الخارجيين.',
  'cal.draft.site': 'الموقع',
  'cal.draft.siteHint': 'لا يحدد الاجتماع الموقع الذي يُعقد فيه.',
  'cal.draft.note': 'تراجع المسودة وتقدّمها بنفسك؛ وتتبع الموافقات سياسة الزوار.',
  'cal.visit.title': 'اجتماع التقويم',
  'cal.visit.sub': 'أُنشئت هذه الزيارة من اجتماع في {provider}.',
  'cal.visit.inSync': 'الزيارة مطابقة للاجتماع.',
  'cal.f.meeting': 'الاجتماع',
  'cal.f.organiser': 'المنظِّم',
  'cal.f.lastChanged': 'آخر تغيير في التقويم',
  'cal.f.revision': 'المراجعة',
  'cal.review.title': 'تغيّر الاجتماع في التقويم',
  'cal.review.cancel': 'أُلغي الاجتماع.',
  'cal.review.titleChange': 'الموضوع: {from} ← {to}',
  'cal.review.schedule': 'الوقت:',
  'cal.review.destination': 'القاعة: {from} ← {to}',
  'cal.review.added': 'ضيف جديد: {name}',
  'cal.review.removed': 'أُزيل ضيف: {name}',
  'cal.review.invitationActive': 'رابط الدعوة فعّال',
  'cal.review.material': 'يؤدي التطبيق إلى طلب الموافقة من جديد لكل من في الزيارة، وتتوقف روابط دعواتهم عن العمل.',
  'cal.review.apply': 'تطبيق على الزيارة',
  'cal.review.dismiss': 'إبقاء الزيارة كما هي',
  'cal.review.applyTitle': 'تطبيق تغييرات التقويم؟',
  'cal.review.applySub': 'تُحدَّث الزيارة عبر تغييرات الزيارة المعتادة.',
  'cal.review.dismissTitle': 'إبقاء الزيارة كما هي؟',
  'cal.review.dismissSub': 'لن تُقترح هذه التغييرات مجدداً ما لم يتغير الاجتماع مرة أخرى.',
  'cal.review.defaultReason': 'تغيّر في اجتماع التقويم.',
  'cal.review.removedImpact': { zero: 'لن يُزال أحد من الزيارة.', one: 'سيُزال شخص واحد من الزيارة؛ وتنتهي موافقاته وروابطه.', two: 'سيُزال شخصان من الزيارة؛ وتنتهي موافقاتهما وروابطهما.', few: 'سيُزال {count} أشخاص من الزيارة؛ وتنتهي موافقاتهم وروابطهم.', many: 'سيُزال {count} شخصاً من الزيارة؛ وتنتهي موافقاتهم وروابطهم.', other: 'سيُزال {count} شخص من الزيارة؛ وتنتهي موافقاتهم وروابطهم.' },
  // ------------------------------------------------------------ روابط التسجيل المسبق (PB-04-10)
  'prl.title': 'روابط التسجيل المسبق',
  'prl.sub': 'شارك رابطاً ليُكمل الزائر ما تطلبه هذه الزيارة قبل الوصول — حتى أثناء انتظار الموافقة.',
  'prl.col.person': 'الزائر',
  'prl.col.checklist': 'قائمة المهام',
  'prl.col.link': 'الرابط',
  'prl.col.action': 'الإجراء',
  'prl.complete': 'مكتملة',
  'prl.outstanding': { zero: 'لا شيء متبقٍ', one: 'مهمة واحدة متبقية', two: 'مهمتان متبقيتان', few: '{count} مهام متبقية', many: '{count} مهمة متبقية', other: '{count} مهمة متبقية' },
  'prl.none': 'لم يُشارك',
  'prl.expires': 'ينتهي {at}',
  'prl.viewed': 'فُتح {at}',
  'prl.notViewed': 'لم يُفتح بعد',
  'prl.share': 'مشاركة الرابط',
  'prl.reissue': 'رابط جديد',
  'prl.revoke': 'إلغاء',
  'prl.foot': 'رابط التسجيل المسبق ليس تصريح زائر: يعرض فقط قائمة مهام الزائر نفسه وطريقة الحصول على المساعدة.',
  'prl.shareTitle': 'رابط التسجيل المسبق لـ {name}',
  'prl.shareSub': 'أرسله إلى هذا الزائر فقط.',
  'prl.create': 'إنشاء رابط',
  'prl.replaces': 'يتوقف الرابط الحالي عن العمل عند إنشاء رابط جديد.',
  'prl.linkLabel': 'رابط التسجيل المسبق',
  'prl.shareWarning': 'يمكن لأي شخص يملك هذا الرابط إكمال قائمة مهام هذا الزائر. ولا يمكن استخدامه للدخول.',
  'prl.revokeTitle': 'إلغاء رابط {name}؟',
  'prl.revokeSub': 'يتوقف الرابط عن العمل فوراً.',
  'prl.status.active': 'فعّال',
  'prl.status.superseded': 'مُستبدَل',
  'prl.status.revoked': 'مُلغى',
  'prl.page.loading': 'جارٍ فتح قائمة مهامك…',
  'prl.page.invalid': 'لم يعد هذا الرابط صالحاً. اطلب رابطاً جديداً من مضيفك.',
  'prl.page.eyebrow': 'قبل زيارتك إلى {site}',
  'prl.page.intro': 'تطلب منك {organisation} إكمال بعض الأمور قبل زيارتك مع {host}.',
  'prl.page.visit': 'زيارتك',
  'prl.page.notPass': 'هذه الصفحة ليست تصريح زائر. يرسل مضيفك التصريح بعد تأكيد الزيارة.',
  'prl.page.validUntil': 'يعمل هذا الرابط حتى {date}.',
  'prl.page.help': 'هل تحتاج إلى مساعدة؟',
  'prl.page.email': 'البريد الإلكتروني',
  'prl.page.phone': 'الهاتف',
  'prl.page.helpHost': 'تواصل مع {host}، مضيفك.',
  'prl.page.nothing': 'لا يلزم فعل أي شيء قبل زيارتك.',
  // ------------------------------------------------------------ المواقع ← تقاويم القاعات (PB-04-13)
  'room.cal.tab': 'تقاويم القاعات',
  'room.cal.panel': 'تقاويم القاعات والموارد',
  'room.cal.panelSub': 'تنشر القاعات المرتبطة بتقويم مورد حجوزات Passage فيه وتستورد الحجوزات المُجراة في مكان آخر. لا يعدّل Passage حجوزات الآخرين أبداً؛ وتظهر الخلافات على شكل تعارضات.',
  'room.cal.noEntitlement': 'لا تملك مؤسستك صلاحية تقاويم القاعات. تُعرض الروابط الحالية للقراءة فقط.',
  'room.cal.rooms': 'القاعات',
  'room.cal.roomsSub': 'يمكن ربط كل قاعة بتقويم مورد واحد.',
  'room.cal.noRooms': 'لا توجد قاعات مفعّلة في هذا الموقع.',
  'room.cal.noConnection': 'فعّل أولاً اتصال تقويم من المستخدمون والصلاحيات ← التقاويم.',
  'room.cal.col.room': 'القاعة',
  'room.cal.col.calendar': 'تقويم المورد',
  'room.cal.col.ownership': 'الاتجاه والحجوزات الخارجية',
  'room.cal.col.sync': 'الحجوزات',
  'room.cal.col.action': 'الإجراء',
  'room.cal.col.kind': 'التعارض',
  'room.cal.col.passage': 'حجز Passage',
  'room.cal.col.provider': 'تقويم المورد',
  'room.cal.col.resolution': 'المعالجة',
  'room.cal.notLinked': 'غير مرتبط',
  'room.cal.bookings': '{synced} منشورة · {pending} بالانتظار · {unknown} غير معروفة · {failed} فاشلة · {conflict} متعارضة',
  'room.cal.lastPublish': 'آخر نشر {at} · {outcome}',
  'room.cal.link': 'ربط التقويم',
  'room.cal.syncNow': 'مزامنة الآن',
  'room.cal.disable': 'تعطيل',
  'room.cal.enable': 'تفعيل',
  'room.cal.result': '{published} منشورة · {removed} مُزالة · {unknown} غير معروفة · {failed} فاشلة · {conflicts} تعارضات · {imported} مقروءة من التقويم',
  'room.cal.conflicts': 'التعارضات',
  'room.cal.conflictsSub': 'تُعرض جنباً إلى جنب. لا يُستبدل شيء حتى يقرر أحد.',
  'room.cal.openCount': { zero: 'لا تعارضات مفتوحة', one: 'تعارض واحد مفتوح', two: 'تعارضان مفتوحان', few: '{count} تعارضات مفتوحة', many: '{count} تعارضاً مفتوحاً', other: '{count} تعارض مفتوح' },
  'room.cal.noConflicts': 'لا تعارضات.',
  'room.cal.open': 'مفتوح',
  'room.cal.resolve': 'معالجة',
  'room.cal.deleted': 'حُذف في التقويم',
  'room.cal.declined': 'رفضته القاعة',
  'room.cal.external': 'حجوزات أُجريت خارج Passage',
  'room.cal.externalSub': 'الحجوزات القادمة المقروءة من تقاويم القاعات المرتبطة (الأوقات فقط).',
  'room.cal.noExternal': 'لا شيء.',
  'room.cal.linkTitle': 'ربط {room} بتقويم مورد',
  'room.cal.linkSub': 'تُقرأ الحجوزات وتُنشر عبر الاتصال المختار.',
  'room.cal.connection': 'الاتصال',
  'room.cal.resourceRef': 'صندوق بريد القاعة أو معرّف تقويم المورد',
  'room.cal.resourceRefHint': 'مثل room1@example.com.',
  'room.cal.modeLabel': 'الاتجاه',
  'room.cal.holdsLabel': 'الحجوزات المُجراة في مكان آخر',
  'room.cal.holdsHint': 'الحظر يرفض حجوزات Passage المتداخلة؛ والتحذير يسجّل تعارضاً بدلاً من ذلك.',
  'room.cal.mode.two_way': 'نشر واستيراد',
  'room.cal.mode.publish_only': 'نشر فقط',
  'room.cal.mode.import_only': 'استيراد فقط',
  'room.cal.holds.block': 'حظر الزيارات المتداخلة',
  'room.cal.holds.warn': 'تحذير فقط',
  'room.cal.kind.external_overlap': 'محجوزة في مكان آخر في الوقت نفسه',
  'room.cal.kind.provider_changed': 'تغيّر حجز Passage في التقويم',
  'room.cal.kind.provider_deleted': 'حُذف حجز Passage في التقويم',
  'room.cal.kind.provider_declined': 'رفضت القاعة الحجز',
  'room.cal.kindHelp.external_overlap': 'حجز أحدهم القاعة في تقويم المورد بينما تشغلها زيارة. اتفقوا على من ينتقل، ثم أقِرّ بذلك.',
  'room.cal.kindHelp.provider_changed': 'نقل أحدهم الحدث الذي نشره Passage. توقف Passage عن تحديثه.',
  'room.cal.kindHelp.provider_deleted': 'حذف أحدهم الحدث الذي نشره Passage. توقف Passage عن تحديثه.',
  'room.cal.kindHelp.provider_declined': 'رفض صندوق بريد القاعة الحجز، غالباً لأنها مشغولة.',
  'room.cal.resolution.reasserted': 'كتابة حجز الزيارة مجدداً',
  'room.cal.resolution.accepted_divergence': 'ترك التقويم كما هو',
  'room.cal.resolution.acknowledged': 'تم الإقرار',
  'room.cal.resolutionHelp.reasserted': 'Passage هو المرجع لحجوزاته: يُعاد الحدث إلى وقت الزيارة وقاعتها.',
  'room.cal.resolutionHelp.accepted_divergence': 'يتوقف Passage عن نشر هذا الحجز. غيّر الزيارة نفسها إذا كان يجب أن يتغير وقتها.',
  'room.cal.resolutionHelp.acknowledged': 'يُسجَّل مع ملاحظتك. لا يتغير أي من الحجزين.',
  'room.cal.resolveTitle': 'معالجة التعارض في {room}',
  'room.cal.enableTitle': 'تفعيل ربط تقويم {room}؟',
  'room.cal.enableSub': 'يُقرأ التقويم من حيث توقف وتُنشر الحجوزات.',
  'room.cal.disableTitle': 'تعطيل ربط تقويم {room}؟',
  'room.cal.disableSub': 'لن يُقرأ أو يُنشر شيء لهذه القاعة بعد الآن.',
};
